import { useSyncExternalStore } from 'react';
import { Circle } from 'lucide-react';
import { getPresentation, getPresentationMode, subscribePresentation } from '../runtime';
export default function FeatureIcon({ name, ...props }) {
  useSyncExternalStore(subscribePresentation, getPresentationMode);
  const Icon = getPresentation().featureIcons?.[name] || Circle;
  return <Icon data-feature-icon={name} {...props} />;
}
